module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('h1', [_vm._v("Klaar!")]), _c('celebration', {
    attrs: {
      "type": _vm.termCelebration
    }
  }), _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group
    }
  }), _c('assignment-feedback', {
    attrs: {
      "assignment": _vm.assignment
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": {
        name: 'assignment.step',
        params: {
          stepIdx: _vm.assignment.steps.length
        }
      }
    }
  }, [_vm._v("Vorige stap")]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87aec8e2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/StepDone.vue
// module id = BF9z
// module chunks = 1